export default [
    {
        path: "allotment/bill",
        name: "allotBill",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/bill/index"),
    },
    {
        path: "allotment/bill/update/:type",
        name: "allotUpdateBill",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/bill/update"),
    },
    {
        path: "allotment/manage",
        name: "allotManage",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/manage/index"),
    },
    {
        path: "allotment/managebill",
        name: "allotManageBill",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/managebill/index"),
    },
    {
        path: "allotment/managebill/update/:type",
        name: "allotUpdateManage",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/bill/update"),
    },
    {
        path: "allotment/managebill/encase",
        name: "allotEncase",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/manage/encase"),
    },
    {
        path: "allotment/inbound",
        name: "allotInbound",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/inbound/index"),
    },
    {
        path: "allotment/inbound/update/:type",
        name: "allotUpdateInbound",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/inbound/update"),
    },
    {
        path: "allotment/outbound",
        name: "allotOutbound",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/outbound/index"),
    },
    {
        path: "allotment/outbound/update/:type",
        name: "allotUpdateOutbound",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/outbound/update"),
    },
    {
        path: "allotment/abnormal",
        name: "allotmentAbnormal",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/abnormal/index"),
    },
    // 虚拟仓库存
    {
        path: "allotment/virtualwarehouse",
        name: "allotvirtualwarehouse",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/virtualwarehouse/index"),
    },
    // 编辑、查看
    {
        path: "allotment/virtualwarehouse/update/:type",
        name: "allotvirtualwarehouseUpdate",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/virtualwarehouse/update"),
    },
    // 万户通页面
    {
        path: "allotment/wanyitong",
        name: "allotWanyitong",
        component: () => import(/* webpackChunkName: "allotment" */ "@/views/allotment/wanyitong/index"),
    },
]